import React from 'react';
export function CrossIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.432 11.984l5.3-5.285a1 1 0 10-1.412-1.416l-5.3 5.285-5.285-5.3A1 1 0 105.319 6.68l5.285 5.3L5.3 17.265a1 1 0 101.412 1.416l5.3-5.285L17.3 18.7a1 1 0 101.416-1.412l-5.284-5.304z"
  }));
}